import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=053c1c84&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=053c1c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c1c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053c1c84')) {
      api.createRecord('053c1c84', component.options)
    } else {
      api.reload('053c1c84', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=053c1c84&scoped=true&", function () {
      api.rerender('053c1c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rpRBnaeS0D7f/JS/comp/DateRange.vue"
export default component.exports